import React, {useState} from 'react';
import {FiArrowLeft, FiEye, FiEyeOff} from 'react-icons/fi';
import {Link, useParams} from 'react-router-dom';

import api from '../../services/api';
import {useToasts} from 'react-toast-notifications'

import logo from '../../assets/fullLogo.png';
import './styles.css';

function ResetPassword() {
    const {addToast} = useToasts();
    const {token} = useParams();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [inputPassword, setInputPassword] = useState('password');

    async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault();

        await api.post('reset', {
            password, confirmPassword, token
        }).then(response => {
            addToast('Senha redefinida com sucesso!', {
                appearance: 'success',
                autoDismiss: true,
            })
        }).catch(e => {
            addToast(e.response.data.message, {
                appearance: 'error',
                autoDismiss: true,
            })
        })
    }

    return (
        <div id="page-create-point">
            <header className={'menu'}>
                <img src={logo} alt="Miaw" width={136}/>
                <nav id="menu">
                    <Link to="/">
                        <FiArrowLeft/>
                        Voltar para home
                    </Link>
                </nav>
            </header>
            <form onSubmit={handleSubmit}>
                <h1>Redefinir senha</h1>
                <fieldset>
                    <legend>
                        <h2>Informe seus dados</h2>
                    </legend>
                    <div className="field">
                        <label htmlFor="password">
                            Nova senha
                        </label>
                        <div>
                            <input
                                type={inputPassword}
                                placeholder="Digite sua senha..."
                                id="password"
                                value={password}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.currentTarget.value)}
                                style={{
                                    marginRight: 8,
                                    width: '95%'
                                }}
                            />
                            {inputPassword === 'password' ? (
                                <i style={{
                                    cursor: 'pointer',
                                    width: '5%'
                                }} onClick={() => setInputPassword('text')}
                                ><FiEye/></i>
                            ) : (
                                <i style={{
                                    cursor: 'pointer',
                                    width: '5%'
                                }} onClick={() => setInputPassword('password')}><FiEyeOff/></i>
                            )}
                        </div>
                    </div>
                    <div className="field">
                        <label htmlFor="password">
                            Confirme a senha
                        </label>
                        <input
                            type="password"
                            placeholder="Digite a confirmação..."
                            id="password"
                            value={confirmPassword}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setConfirmPassword(e.currentTarget.value)}
                        />
                    </div>
                </fieldset>
                <button type="submit">Recuperar</button>
            </form>
        </div>
    );
}

export default ResetPassword;
